<script lang="ts">
    import { FieldErrors } from 'formsnap';
    import { t } from 'svelte-i18n';

    const defaultErrorMessages: [string, string][] = Object.entries({
        'Invalid type: Expected true but received false': 'error.invalidType',
        'Invalid length: Expected !0 but received 0': 'error.notEmpty',
        'Invalid length: Expected >=': 'error.invalidLength',
        'Invalid format: Expected /[a-z]/': 'error.invalidSmallLetterFormat',
        'Invalid format: Expected /[A-Z]/': 'error.invalidBigLetterFormat',
        'Invalid email': 'error.invalidEmail'
    });

    function mapErrorMessages(errors: string[]): string[] {
        const errorMessages = errors.map(
            (error) => defaultErrorMessages.find(([key]) => error.startsWith(key))?.[1] ?? error
        );

        return errorMessages.filter((error, index) => errorMessages.indexOf(error) === index);
    }
</script>

<FieldErrors let:errors let:errorAttrs>
    {#each mapErrorMessages(errors) as error}
        <div {...errorAttrs} class="text-accent my-1.5 text-15px">{error.startsWith('error.') ? $t(error) : error}</div>
    {/each}
</FieldErrors>
